<section id="experience" class="content">
    <div class="wrapper">
        <h2>This ain’t my first rodeo, my friend.</h2>
        <p>
            In 2016 I completed my degree in Software Engineering (Honours, First-Class) at the <a href="https://www.unisa.edu.au/">University
            of South Australia</a>. I’ve been churning out code ever since.
        </p>
        <p>
            I started my career by founding a web design and development agency. Throughout my
            studies I grew the business from a hobby to my main source of income. It was here that my passion for
            early-stage companies began.
        </p>
        <p>
            In 2017 I accepted a Graduate Software Engineer position at the <a href="https://www.d2dcrc.com.au/">Data to
            Decisions CRC</a>. D2D was a five year Cooperative Research Centre (CRC) and was formed to assist Australia's national security
            and defence agencies to tackle big data challenges. The CRC wrapped up on 30 June 2019.
        </p>
        <p>
            Upon the completion of the D2D CRC, <a href="https://www.fivecast.com/">Fivecast</a> was spun out to
            commercialise some of its research efforts.
            Focused on risk analytics, Fivecast uses machine learning and AI to extract insights from
            open-source data. I am very proud to be a part of the founding Fivecast team.
        </p>
        <p>
            And I've been startup obsessed ever since, working as a senior software engineer at
            <a href="https://www.giraffe.build/">Giraffe</a>, as the lead engineer at
            <a href="https://cloudfloat.com/">Cloudfloat</a>,
            and most recently as the Technical Lead at <a href="https://www.mirai.au/">Mirai</a>.
        </p>
    </div>
</section>